<template src="./html/Create.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Treeselect from '@riophae/vue-treeselect'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'treeselect': Treeselect,
		},
		data () {
			return {
				modal: {
					selector: 'modal-create-product-category-' + new Date().getTime(),
				},

				statuses: null,
				categories: null,
				languages: null,

				item: {
					title: null,
					slug: null,
					description: null,
					icon: null,
					color: "#000000",
					sort: null,
					private: true,
					parent_id: null,
					lang_id: null,
					status_id: 2,
				},
			}
		},
		watch: {
			'item.title'() {
				this.item.slug = this.$options.filters.slugify(this.item.title)
			},
		},
		created() {
			this.$validator.extend('existsSlugCreate', {
				getMessage: field => 'Título no disponible.',
				validate: (value) => {
					if(value) {
						var data = {
							slug: this.item.slug,
							lang_id: this.item.lang_id,
						}
						return this.$http.post('admin/management/products/categories/validation/exists', data)
						.then(response => {
							return {
								valid: response.body.valid
							}
						}).catch(function(response) {
							console.log(response)
						})
					} else {
						return false
					}
				}
			});
		},
		methods: {
			open() {
				this.clearData()
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getStatuses()
				this.getCategories()
				this.getLanguages()
			},
			clearData() {
				this.errors.clear()
				this.item.title = null
				this.item.description = null
				this.item.icon = null
				this.item.color = "#000000"
				this.item.sort = null
				this.item.private = true
				this.item.parent_id = null
				this.item.lang_id = this.$platform.lang_id
				this.item.status_id = 2
			},
			getStatuses() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				})
			},
			getCategories: function() {
				this.$http.get('admin/management/products/categories')
					.then(response => {
						this.categories = response.body
					})
			},
			normalizerTreeselectCategory(node) {
				return {
					id: node.id,
					label: node.title,
					children: node.children,
				}
			},
			getLanguages() {
				this.$http.get('languages')
				.then(response => {
					this.languages = response.body
					this.loadLanguage()
				})
			},
			loadLanguage() {
				if(this.languages) {
					if(this.languages.length) {
						var that = this
						var found = this.languages.find(function(language) {
							return language.lang_code == that.$i18n.locale
						})
						if(found) {
							this.item.lang_id = found.id
						}
					}
				}
			},
			validate(event) {
				event.stopPropagation()
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.store()
					}
					return result
				})
			},
			store () {
				var btnStore = Ladda.create(this.$refs.btnStore)
				btnStore.start()
				this.$http.post('admin/management/products/categories', this.item)
				.then(response => {
					this.close()
					this.$emit('reload')
					btnStore.stop()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					btnStore.stop()
					this.$emit('reload')
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productCategories/views/Create.vue